import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    state: {
        type: 'default',// 'default' | 'decoration'
        mode: 'user',// 'user' | 'live' | 'tour'
        split: false
    }
}

export const spaceSlice = createSlice({
    name: 'space',
    initialState,
    reducers: {
        // state的集合体
        setSpaceStateToStore: (state, action) => {
            state.state = Object.assign({}, state.state, action.payload)
        }
    },
    extraReducers: (builder => {})
})

export const {
    setSpaceStateToStore
} = spaceSlice.actions

export const getSpaceState = (state) => state.space.state

export default spaceSlice.reducer
